import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { MultiRadioButtonCustomization } from './multi-radiobutton-edit';

type GroupAnswer = Record<string, string | number | null>;

@Component({
  selector: 'lib-multi-radiobutton-compiling',
  imports: [FormsModule, RadioButtonModule, DecimalPipe],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex w-full flex-col gap-3">
        <span class="whitespace-pre-line text-justify">
          {{ widget.customization.description }} (max
          {{ widgetService.maxPoints() | number: '1.0-1' }}
          pt)
        </span>
        @for (
          group of widget.customization.groups;
          track group.key;
          let g = $index
        ) {
          <div class="flex w-full flex-col gap-1">
            <span class="font-medium">{{ group.label }}</span>
            <div
              [class]="'p-fluid flex' + topologyStyle"
              (keydown)="onKeyDown($event)"
            >
              @for (option of group.options; track $index; let i = $index) {
                <div class="flex flex-row items-center gap-2 whitespace-nowrap">
                  @let id = groupId + '_' + group.key + '_option_' + i;
                  <p-radioButton
                    [autofocus]="false"
                    [inputId]="id"
                    [name]="groupId + '_' + group.key"
                    [value]="option.value"
                    [ngModel]="selectedValue(group.key)"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="select(group.key, $event)"
                  ></p-radioButton>
                  <label [for]="id">
                    {{ option.label }}
                  </label>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class MultiRadioButtonCompilingComponent {
  protected widgetService = inject(
    CompilingWidgetService<MultiRadioButtonCustomization, GroupAnswer>,
  );

  protected topologyStyle = ' flex-row flex-wrap gap-x-5 gap-y-2';
  protected groupId = `'multiRadioButton_${this.widgetService.uniqueId}`;

  protected selectedValue(key: string): string | number | null {
    return this.widgetService.formControl()?.value?.[key] ?? null;
  }

  protected select(key: string, value: string | number | null) {
    const control = this.widgetService.formControl();
    if (!control) return;

    const current =
      control.value && typeof control.value === 'object' ? control.value : {};
    control.setValue({ ...current, [key]: value });
    control.markAsDirty();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
